import PropTypes from 'prop-types'
import CheckboxField from '../../molecules/fields/CheckboxField'
import Value from '../../molecules/Value'
import TextField from '../../molecules/fields/TextField'
import * as validations from '../../../utils/validations'
import React from 'react'
import { useField } from 'react-final-form'

const Hint = ({ baseName }) => {
  const { input: hint } = useField(`${baseName}.hint`)

  const handleChange = () => {
    hint.onChange(null)
  }
  return (
    <div className="w-full">
      <CheckboxField
        className="ml-0.5"
        name={`${baseName}.has_hint`}
        margin="dense"
        label="Agregar descripción"
        onChange={handleChange}
        noYpadding
      />
      <Value name={`${baseName}.has_hint`}>
        {({ value }) =>
          value && (
            <TextField
              name={`${baseName}.hint`}
              margin="dense"
              size="full"
              validate={validations.required()}
              maxLength={150}
              element="textarea"
              dataTestid="hintQuestion"
              capsLockInfo
            />
          )
        }
      </Value>
    </div>
  )
}

export default Hint

Hint.propTypes = {
  baseName: PropTypes.string
}
